module.exports = __webpack_public_path__ + "img/sri-lanka.0cbb8160.svg";